import {createModel} from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
    ProSkillAssureAnswerCodeSubmitModel
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAnswerCodeSubmitModel";
import {
    ProSkillAssureAnswerCodeSubmitType
} from "~~/package/mapper/proSkillAssure/model/assessment/ProSkillAssureAnswerCodeSubmitType";

export class ProSkillAssureAnswerCodeModel extends Model {
    constructor(
        public action: ProSkillAssureAnswerCodeSubmitType = ProSkillAssureAnswerCodeSubmitType.RUN,
        public submit: ProSkillAssureAnswerCodeSubmitModel = new ProSkillAssureAnswerCodeSubmitModel()
    ) {
        super();
    }

    static create(model: Partial<ProSkillAssureAnswerCodeModel>): ProSkillAssureAnswerCodeModel {
        return createModel<ProSkillAssureAnswerCodeModel>(ProSkillAssureAnswerCodeModel, {...model});
    }
}
